<template>
  <FormInputWrapper :error="error" :helper-text="helperText" :label="label" :lang="lang" :note="note" :required="required">
    <Textarea v-bind="$attrs" :custom-class="customClass" :is-error="isError" />
  </FormInputWrapper>
</template>

<script setup lang="ts">
import type { Lang } from '@/models/lang';
import { FormInputWrapper, Textarea } from '@/wabunka-src/common/components';

defineOptions({
  inheritAttrs: false,
});

interface Props {
  label: string;
  note?: string;
  required?: boolean;
  error?: string;
  lang?: Lang;
  helperText?: string;
  customClass?: string;
}

const props = withDefaults(defineProps<Props>(), {
  note: '',
  required: true,
  error: '',
  lang: 'jp',
  helperText: '',
});

const isError = computed(() => !!props.error && props.error !== '');
</script>
